/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { IdentityVerificationPersonaService } from '../../../services/identity-verification-persona.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ut-persona-verification-banner',
  templateUrl: './persona-verification-banner.component.html',
  styleUrl: './persona-verification-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe],
})
export class PersonaVerificationBannerComponent implements OnInit {
  @Input() link: string;

  isVisible$: Observable<boolean>;

  constructor(private identityVerificationPersonaService: IdentityVerificationPersonaService) {}

  ngOnInit(): void {
    this.isVisible$ = this.identityVerificationPersonaService.isVerificationRequested();
  }
}
